import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  DEFAULT_TIMEOUT,
  handleError,
  HttpRequestMethods,
  IDP_APPS
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CarsLocationItem,
  CarsLocationResponse
} from '../../models/interface/booking-cars/booking-cars.interfaces';

const CARS_LOCATION_SEARCH = 'CARS_LOCATION_SEARCH';

@Injectable({ providedIn: 'root' })
export class BookingCarsApiService {
  private http = inject(HttpClient);
  private appConfigService = inject(AppConfigService);
  private _errorHandler = handleError.bind(this);

  private getLocationCode = (item: CarsLocationResponse['sr'][0]): string =>
    item.hierarchyInfo?.airport?.airportCode || item.gaiaId || '';

  private getLocationName = (item: CarsLocationResponse['sr'][0]): string =>
    item.regionNames?.fullName || item.regionNames?.shortName || '';

  private mapToLocationItem = (
    item: CarsLocationResponse['sr'][0]
  ): CarsLocationItem => ({
    code: this.getLocationCode(item),
    name: this.getLocationName(item),
    gaiaId: item.gaiaId || ''
  });

  searchLocations(query: string): Observable<CarsLocationItem[]> {
    const params = this.buildSearchParams();
    const queryWithParams = `/${query}?${params.toString()}`;

    return new ApiBuilder<void, CarsLocationResponse>(
      this.http,
      this.appConfigService
    )
      .app(IDP_APPS.HEADER)
      .endpointKey('CARS_TYPEAHEAD')
      .method(HttpRequestMethods.GET)
      .queryParams(queryWithParams)
      .errorHandler(this._errorHandler)
      .timeOut(DEFAULT_TIMEOUT)
      .library(CARS_LOCATION_SEARCH)
      .create()
      .pipe(
        map(
          (response: CarsLocationResponse) =>
            response.sr?.map(this.mapToLocationItem) || []
        )
      );
  }

  private buildSearchParams(): URLSearchParams {
    const params = this.getDefaultSearchParams();
    return new URLSearchParams(params);
  }

  private getDefaultSearchParams(): Record<string, string> {
    return {
      client: 'Homepage',
      lob: 'CARS',
      regiontype: '1583',
      siteid: '509010011'
    };
  }
}
